import { render, staticRenderFns } from "./costPerService.vue?vue&type=template&id=1f2628f8"
import script from "./costPerService.vue?vue&type=script&lang=js"
export * from "./costPerService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports